import CloseIcon from '@mui/icons-material/Close';
import * as React from 'react';
import './index.scss';

export interface OptionProps {
  label: string;
  value: string;
  onClick?: () => void;
}

export const Option: React.FC<OptionProps> = ({ label, value, onClick }) => (
  <div className="Option">
    <div className="Option__labels">
      <div className="Option__label">
        <span>{label}</span>
      </div>
      <div className="Option__value">
        <span>{value}</span>
      </div>
    </div>
    {onClick && <CloseIcon className="Option__close" onClick={onClick} />}
  </div>
);
